// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationPrescriber } from './priorAuthorizationPrescriber.js';
import type { PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis } from './priorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis.js';
import type { PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient } from './priorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient.js';
import type { PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPayor } from './priorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPayor.js';
import type { PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPrescription } from './priorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPrescription.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationRequestBase {
    'diagnosis'?: PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis | null;
    'patient': PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient | null;
    'payor': PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPayor | null;
    'prescriber': PriorAuthorizationPrescriber | null;
    'prescription': PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPrescription | null;
    'project'?: string | null;
    'notificationPhoneNumber'?: string | null;
    'notificationName'?: string | null;
    'clientId1'?: string | null;
    'clientId2'?: string | null;
    'clientId3'?: string | null;
    'clientId4'?: string | null;
    'clientId5'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationRequestBase>> = [
        {
            "name":     "diagnosis",
            "baseName": "diagnosis",
            "type":     "PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationDiagnosis"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPatient"
        },
        {
            "name":     "payor",
            "baseName": "payor",
            "type":     "PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPayor"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "PriorAuthorizationPrescriber"
        },
        {
            "name":     "prescription",
            "baseName": "prescription",
            "type":     "PriorAuthorizationV1PriorAuthorizationInterfacesPriorAuthorizationPrescription"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "notificationPhoneNumber",
            "baseName": "notificationPhoneNumber",
            "type":     "string"
        },
        {
            "name":     "notificationName",
            "baseName": "notificationName",
            "type":     "string"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
        {
            "name":     "clientId3",
            "baseName": "clientId3",
            "type":     "string"
        },
        {
            "name":     "clientId4",
            "baseName": "clientId4",
            "type":     "string"
        },
        {
            "name":     "clientId5",
            "baseName": "clientId5",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationRequestBase.attributeTypeMap;
    }
}
